import type React from 'react'
import {ModalWrapper} from '@/components/GDS/molecules/Modal'
import './Shared/OnboardingFormShared.module.css'

interface SelfOnboardingModalWrapperProps extends React.ComponentProps<typeof ModalWrapper> {
  className?: string
}

const SelfOnboardingModalWrapper: React.FC<SelfOnboardingModalWrapperProps> = ({title, children, ...rest}) => {
  return (
    <ModalWrapper type="L" text="" {...rest} title={title}>
      {children}
    </ModalWrapper>
  )
}

export default SelfOnboardingModalWrapper
